import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Collapse, useTheme } from "@mui/material";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import RecipientFeedList from "@/components/RecipientFeedList";
import theme from "@/theme/theme.tsx";

export default React.memo(function SelectNonGroups({
  index,
  data,
  activeChannels,
  toggleAllGroupFeeds,
  toggleSingleFeed,
  openGroups,
  toggleOpenGroup,
  containerClassList,
}: {
  index: number;
  data: any[];
  activeChannels: string[];
  toggleAllGroupFeeds: (ids: string[]) => void;
  toggleSingleFeed: (id: string) => void;
  openGroups: string[];
  toggleOpenGroup: (groupId: string) => void;
  containerClassList: { active: object; inactive: object };
}) {
  const theme = useTheme();
  const activeContainerClass = data?.some((feed) => activeChannels.includes(feed.id))
    ? containerClassList.active
    : containerClassList.inactive;
  return (
    <Box sx={{ ...activeContainerClass }} key={`select-non-groups-${index}`}>
      {data?.length > 0 && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              data-sb={TestIds.fleet.recipientGroup}
              sx={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
                gap: 1,
              }}
              onClick={() => toggleOpenGroup("non-grouped-feeds")}
            >
              <Box sx={{ display: "flex" }}>
                {openGroups.includes("non-grouped-feeds") ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </Box>
              <Box sx={{ fontWeight: "bold", display: "flex" }}>Non Grouped Feeds ({data.length})</Box>
            </Box>
          </Box>

          <Collapse in={openGroups.includes("non-grouped-feeds")} unmountOnExit mountOnEnter>
            <Box sx={{ mt: 1, p: 1 }}>
              {data?.length > 1 && (
                <Box
                  data-sb={TestIds.fleet.recipientGroupToggle}
                  onClick={() => toggleAllGroupFeeds(data.map((feed) => feed.id))}
                  sx={{ display: "flex", gap: 2 }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 1,
                      ml: 0.5,
                      mb: 1,
                    }}
                  >
                    {activeChannels.some((feedId) => data.map((feed) => feed.id).includes(feedId)) ? (
                      <>
                        <Box sx={{ display: "flex" }}>
                          <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                        </Box>
                        <Box>De-Select All</Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ display: "flex" }}>
                          <CheckBoxOutlineBlankIcon
                            sx={{
                              color: theme.palette.brand.other.gray.main,
                            }}
                          />
                        </Box>
                        <Box>Select All</Box>
                      </>
                    )}
                  </Box>
                </Box>
              )}
              <RecipientFeedList
                id="non-grouped-feeds"
                feeds={data}
                activeChannels={activeChannels}
                toggleSingleFeed={toggleSingleFeed}
              />
            </Box>
          </Collapse>
        </>
      )}
    </Box>
  );
});
